import * as React from 'react';
import { AnalyticsStore } from 'bernie-core';
import { ILocalization } from 'bernie-l10n';

import { PropertyDetailsSegment } from './property-details-segment';
import { PropertyInfoSectionViewModel, PropertyInfoSubSectionViewModel } from 'models';
import { renderAlternativeNames, renderAmenityBody, renderAmenitySection } from './render-amenity-helper';
import { PropertyAlternativeNameModel } from 'src/common/models/hotel/hotel-details-types';
import { UitkLink } from 'uitk-react-link';

interface ImportantInfoProps {
  analytics?: AnalyticsStore;
  importantInfo?: PropertyInfoSectionViewModel;
  l10n: ILocalization;
  shouldMention?: PropertyInfoSubSectionViewModel;
  propertyAKA?: PropertyAlternativeNameModel;
  isToggleHidden?: boolean;
  hrefNextPage?: string;
}

export const ImportantInfo: React.FunctionComponent<ImportantInfoProps> = ({
  analytics,
  importantInfo,
  l10n,
  shouldMention,
  propertyAKA,
  isToggleHidden = false,
  hrefNextPage
}) => {
  const { formatText } = l10n;

  const showShouldMention = Boolean(shouldMention && shouldMention.title && shouldMention.body && shouldMention.body.length > 0);
  const imptInfoAnalytics = analytics.setupTracker('.ImptInfo', 'SeeMore_SeeLess');
  const secondaryTitleClassNames = 'policies__header--secondary uitk-type-heading-400 uitk-type-bold';

  return (
    Boolean(importantInfo) && (
      <PropertyDetailsSegment
        analytics={imptInfoAnalytics}
        dataStid="section-info-important-policies"
        errorBoundaryLabel="hotel.information.policies.importantInfo"
        rootClassName="info-important"
        title={importantInfo.title}
        isToggleHidden={isToggleHidden}
      >
        {importantInfo.sections.map((section, index) => renderAmenitySection(section, index, 'important'))}

        {showShouldMention && (
          <div className="info-should-mention policies__section--text">
            <h4 className={`info-should-mention__section__title ${secondaryTitleClassNames}`}>{shouldMention.title}</h4>
            {shouldMention.body.map((text, index) => renderAmenityBody(text, index, 'should-mention'))}
          </div>
        )}

        {propertyAKA &&
          propertyAKA.sections &&
          propertyAKA.sections.length > 0 && (
            <div className="info-property-alternative-name policies__section--text all-y-padding-three">
              <h4 className={`info-property-alternative-name__section__title ${secondaryTitleClassNames}`}>{propertyAKA.title}</h4>
              <div className={'policies__body uitk-type-list-300 info-important__section__body'}>
                <ul>{propertyAKA.sections.map(section => renderAlternativeNames(section))}</ul>
              </div>
            </div>
          )}

        {hrefNextPage && (
          <UitkLink>
            <a href={hrefNextPage} className="uitk-cell all-l-padding-four" target="_blank">
              {formatText('hotels.infosite.policies.allReviews')}
            </a>
          </UitkLink>
        )}
      </PropertyDetailsSegment>
    )
  );
};
